// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"aa7b357b","488":"09663278"}[chunkId] + ".chunk.js";
};